import styled from 'styled-components';
import { glassMedium, glassHover } from '../../styles/components/common/glassmorphism';

const ProfileSection = styled.div`
  ${glassMedium}
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  color: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  &:hover {
    ${glassHover}
  }
`;

const ItemContainer = styled.div`
  position: relative;
  padding: 1rem;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.05);
  margin-bottom: 1rem;
`;

const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

const ItemTitle = styled.h4`
  margin: 0;
  color: rgba(255, 255, 255, 0.95);
`;

const ItemSubtitle = styled.p`
  margin: 0 0 0.5rem 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
`;

const ItemContent = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
`;

export { ProfileSection, ItemContainer, ItemHeader, ItemTitle, ItemSubtitle, ItemContent }; 